var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEcosystemNotificationMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.801 5.80085C12.801 4.52759 12.2952 3.30647 11.3948 2.40614C10.4945 1.5058 9.27337 1 8.0001 1C6.72684 1 5.50572 1.5058 4.60539 2.40614C3.70506 3.30647 3.19925 4.52759 3.19925 5.80085C3.19925 11.4018 0.798828 13.0021 0.798828 13.0021H15.2014C15.2014 13.0021 12.801 11.4018 12.801 5.80085Z",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.38397 16.2026C9.2433 16.4451 9.04138 16.6464 8.79845 16.7864C8.55551 16.9263 8.28008 16.9999 7.99972 16.9999C7.71937 16.9999 7.44394 16.9263 7.201 16.7864C6.95806 16.6464 6.75615 16.4451 6.61548 16.2026",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcosystemNotificationMenu);
export default __webpack_public_path__ + "static/media/ecosystem-notification-menu.fab4f5e36632677137949543e8980b52.svg";
export { ForwardRef as ReactComponent };